import type { WizardAction, WizardState, WizardStep } from "./wizard-types"

export const initialWizardState: WizardState = {
  step: "entry",
  path: null,
  answers: {
    problem: "",
    users: "",
    sites: [],
    solution: "",
    dataSources: "",
  },
  selectedTemplate: null,
  generatedData: null,
}

const AI_STEPS: WizardStep[] = [
  "interview-1",
  "interview-2",
  "interview-3",
  "interview-4",
  "generating",
]

function nextAiStep(current: WizardStep): WizardStep {
  const idx = AI_STEPS.indexOf(current)
  if (idx >= 0 && idx < AI_STEPS.length - 1) return AI_STEPS[idx + 1]
  return current
}

function prevAiStep(current: WizardStep): WizardStep {
  const idx = AI_STEPS.indexOf(current)
  if (idx > 0) return AI_STEPS[idx - 1]
  return "entry"
}

export function wizardReducer(state: WizardState, action: WizardAction): WizardState {
  switch (action.type) {
    case "SET_PATH":
      if (action.path === "ai") return { ...state, path: "ai", step: "interview-1" }
      if (action.path === "template") return { ...state, path: "template", step: "template" }
      return { ...state, path: action.path }

    case "SET_ANSWER":
      return {
        ...state,
        answers: { ...state.answers, [action.field]: action.value },
      }

    case "NEXT_STEP":
      if (state.path === "ai") {
        return { ...state, step: nextAiStep(state.step) }
      }
      return state

    case "PREV_STEP":
      if (state.step === "summary") {
        if (state.path === "ai") return { ...state, step: "interview-4", generatedData: null }
        if (state.path === "template")
          return { ...state, step: "template", generatedData: null, selectedTemplate: null }
        return { ...state, step: "entry" }
      }
      if (state.path === "ai") {
        return { ...state, step: prevAiStep(state.step) }
      }
      if (state.step === "template") {
        return { ...state, step: "entry", path: null }
      }
      return { ...state, step: "entry", path: null }

    case "SET_GENERATED":
      return { ...state, generatedData: action.data, step: "summary" }

    case "SELECT_TEMPLATE":
      return {
        ...state,
        selectedTemplate: action.templateId,
        generatedData: action.data,
        step: "summary",
      }

    case "RESET":
      return initialWizardState

    default:
      return state
  }
}
